// Solutions order should be updated in this array
// If new solution is added, include its label all lower case in this array
const solutionOptions = [
  'vehicles', 'software', 'service', 'charging', 'financing',
];

const softwareOption = { label: 'Software', value: 'software-hardcode' };

const updateSolutionsOrder = (solutions) => {
  const orderedSolutions = [];

  solutions.forEach((solution) => {
    const index = solutionOptions.findIndex(
      (option) => solution.label.toLowerCase().includes(option),
    );

    if (solution.label.toLowerCase().includes('software')) {
      orderedSolutions[index] = softwareOption;
    } else {
      orderedSolutions[index] = solution;
    }
  });

  return orderedSolutions.filter((solution) => solution !== undefined);
};

export default updateSolutionsOrder;
